import { host, logoUrl, paths } from '@natu/utils/paths';

import { ArticleNodeAuthor } from '../../../../../../utils/src/types/Blog/ArticleNode.types';

interface ArticleSchemaProps {
  firstPublishedAt?: string;
  title?: string;
  description?: string;
  author?: ArticleNodeAuthor;
  previewImage?: string;
  slug?: string;
  authorImage?: string;
}

export const ArticleSchema = ({
  firstPublishedAt,
  title,
  description,
  author,
  previewImage,
  slug,
  authorImage,
}: Partial<ArticleSchemaProps>) => {
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${host}/${slug}`,
    },
    url: `${host}/${slug}`,
    headline: title || '',
    description: description || title || '',
    image: previewImage ? [previewImage] : [],
    datePublished: firstPublishedAt || new Date().toISOString(),
    isAccessibleForFree: true,
    author: author
      ? {
          '@type': 'Person',
          name: author.name || '',
          url: `${host}${paths.blog}${paths.authors}/${author.slug}`,
          ...(authorImage && { image: authorImage }),
        }
      : {},
    publisher: {
      '@type': 'Organization',
      name: 'Naturaily',
      logo: {
        '@type': 'ImageObject',
        url: logoUrl,
      },
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }}
    />
  );
};
